import React from 'react';
import { Container } from 'react-bootstrap';

const VerifyInvitationPage: React.FC = () => {
  return (
    <Container className="py-5 text-center">
      <p className="lead text-muted">Verifying your invitation...</p>
    </Container>
  );
};

export default VerifyInvitationPage;
